enum OutputType {
  /** Portable Network Graphics (bitmap) */
  PNG = 'png',
  /** Scalable Vector Graphics */
  SVG = 'svg',
  /** Adobe Encapsulated PostScript */
  EPS = 'eps'
}

export default OutputType
